
import { API_ROUTES } from "@/constants";
import { transformMainFilter } from "@/helpers/filters";
import { IGetFilterDataRes, ISaveFilterReq, ISaveFilterRes } from "@/types/Filters";

import { ApiService } from "./ApiService";

async function saveFilterSearchService(filters: any, refresh?: boolean): Promise<ISaveFilterRes> {
    const requestBody: ISaveFilterReq = {
        filterData: transformMainFilter(filters),
    };
    if (refresh) {
        requestBody.refresh = true;
    }
    return await ApiService.post(API_ROUTES.SAVE_FILTERS, requestBody);
}

async function getFilterSearchService(searchId: string): Promise<IGetFilterDataRes> {
    return await ApiService.get(`${API_ROUTES.GET_SEARCH_DATA}/${searchId}`);
}
export {
    saveFilterSearchService,
    getFilterSearchService,
};
